
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

import afi from "@assets/constantes/afi.json";

import { CuentaCp } from "@shared/Entities/AFI/cuenta.entity";
import { Promotor } from "@shared/Entities/AFI/promotor.entity";

import { ClientMovement, FondoCliente } from "@AFI/Types/Interfaces/client-movements.interface";

import { AFIRepository } from "../afi.repository";
import { PersonalCustomerAccount } from "../Types/Interfaces/fondo-inversion.interface";

@Injectable({
  providedIn: "root",
})
export class FondoInversionService {
  constructor(private afiRepository: AFIRepository) {}

  public getPersonalCustomerAccounts(): Observable<PersonalCustomerAccount[]> {
    return this.afiRepository.getPersonalCustomerAccounts();
  }

  public getCustomerFunds(): Observable<FondoCliente[]> {
    return this.afiRepository.obtenerFondosClientes();
  }

  public getPromotor(identification: string): Observable<Promotor> {
    return this.afiRepository.obtenerPromotor(identification);
  }

  public getTipoDeAportes(isPersonalCustomer: boolean): any {
    return isPersonalCustomer ? afi.personal.notificacionAportes.tiposAporte : afi.corporativo.notificacionAportes.tiposAporte;
  }

  public obtenerCuentasCp(): Observable<CuentaCp[]> {
    return this.afiRepository.getPersonalCustomerAccounts();
  }

  public getClienteMovements(fechaInicio: Date, fechaFin: Date, cuentas: string[]): Observable<ClientMovement[]> {
    return this.afiRepository.obtenerMovimientosClientes(fechaInicio, fechaFin, cuentas).pipe(
      map((movimientos) => {
        return movimientos;
      })
    );
  }
}
